import type { FC } from 'react';

import { CallDetailsParticipant } from 'features/call/call-details/components';
import {
  useCallDetailsCallee,
  useCallDetailsCaller,
} from 'features/call/call-details/hooks';
import { Separator } from 'features/call/call-details/styles';
import { CallDetailsParticipantChangePhoneNumberVco2Line } from 'features/vco-2-line/components';
import { useAppSelector } from 'features/app/hooks';
import { isTwoLineVcoConnectingSelector } from 'features/call/call-hearing/store';

export const CallDetailsChangeNumberVco2Line: FC = () => {
  const { caller } = useCallDetailsCaller();
  const { callee } = useCallDetailsCallee();
  const isVcoTwoLineConnecting = useAppSelector(isTwoLineVcoConnectingSelector);

  return (
    <>
      <CallDetailsParticipant {...caller} />
      {!isVcoTwoLineConnecting && (
        <CallDetailsParticipantChangePhoneNumberVco2Line />
      )}

      <Separator />
      <CallDetailsParticipant {...callee} />
    </>
  );
};
